import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createTutorProfile } from "../../../store/profile/profileActions";
import { useNavigate } from "react-router";
import { SwitchTutorForm } from "./switch-tutor-form";
import { ProfileRole, ProfileStatusEnum } from "../../../store/profile/profileSlice";
import { defaultTutorBootstrapPayload } from "./tutor-defaults";

const SwitchTutor = () => {
    const [currentStep, setCurrentStep] = useState(3);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profileList = useSelector((state) => state.auth.profileList);
    const tutor = profileList.find(v => v.role === ProfileRole.TUTOR);
    useEffect(() => {
        if (!tutor) {
            dispatch(createTutorProfile(defaultTutorBootstrapPayload));
            return;
        }
        if (tutor.status === ProfileStatusEnum.waitForApproval) {
            setCurrentStep(10);
            return;
        }
        if (tutor.status === ProfileStatusEnum.active) {
            navigate("/");
        }
    }, [dispatch, navigate, tutor])

    return (
        <SwitchTutorForm currentStep={currentStep} setCurrentStep={setCurrentStep} />
    )
}

export { SwitchTutor }
